module.exports = __webpack_public_path__ + "img/ldyTitle3.72786a00.png";